"use client";

import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import Image from "next/image";
import { SanityClientStory } from "@/sanity/lib/types";
import { urlFor } from "@/sanity/lib/image";
import ClientStoryCard from "../ui/ClientStoryCard";

export default function ClientStoriesHero({
  stories,
}: {
  stories: SanityClientStory[];
}) {
  const [emblaRef] = useEmblaCarousel(
    {
      loop: true,
      duration: 80,
      align: "start",
    },
    [Autoplay({ delay: 8000, playOnInit: true })],
  );

  return (
    <section className="selection:!bg-accent relative z-10 mx-auto mb-20 max-w-300 overflow-x-hidden px-6 pt-30 lg:mb-45 lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-10 lg:gap-y-0 lg:pt-40">
      <div className="relative z-10 w-full text-center lg:min-w-0 lg:text-left">
        <div className="text-accent mb-4 text-5xl font-extrabold uppercase md:text-6xl lg:text-8xl">
          Client Success Stories
        </div>
        <p className="mx-auto max-w-xl lg:mx-0">
          How teams build lasting products with dedicated developers from
          Remotecoders—real partnerships, real outcomes.
        </p>
      </div>
      <div className="relative mt-10 hidden min-w-0 w-full lg:mt-6 lg:block">
        <div className="w-full overflow-hidden" ref={emblaRef}>
          <div className="flex touch-pan-y">
            {stories
              ?.slice()
              .reverse()
              .map((story) => (
                <div className="max-w-lg shrink-0 grow-0" key={story._id}>
                  <ClientStoryCard
                    companyName={story.companyName}
                    summary={story.summary}
                    logoUrl={urlFor(story.companyLogo)
                      .width(180)
                      .height(180)
                      .url()}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="absolute inset-0 z-[1] hidden lg:hidden">
        <Image
          src="/shapes/group-43.svg"
          alt="shape"
          width={100}
          height={100}
          className="absolute top-1/5 right-1/10 h-auto w-25"
        />
      </div>
    </section>
  );
}
